module.exports = __webpack_public_path__ + "public/adminIcons/LoginPageVector.svg?69262549";